import { useGraphStore } from '@/stores/graph';
import { Loader2 } from 'lucide-react';

export function GraphStatusBar() {
  const { snapshot, vizLoading, filters } = useGraphStore();

  if (vizLoading) {
    return (
      <div className="absolute inset-0 z-30 flex items-center justify-center bg-slate-900/70 backdrop-blur-sm pointer-events-none">
        <div className="flex flex-col items-center gap-3">
          <div className="w-8 h-8 border-2 border-teal-400/20 border-t-teal-400 rounded-full animate-spin" />
          <span className="text-xs text-slate-400">
            {filters.layout === 'embedding'
              ? 'Computing embedding projection...'
              : 'Loading graph topology...'}
          </span>
        </div>
      </div>
    );
  }

  if (!snapshot) return null;

  return (
    <div className="absolute bottom-3 left-3 z-20">
      <div className="bg-slate-900/80 backdrop-blur border border-slate-700/50 rounded-lg px-3 py-1.5 flex items-center gap-4 text-xs">
        <span className="text-slate-400">
          <strong className="text-white">
            {snapshot.meta.node_count.toLocaleString()}
          </strong>{' '}
          nodes
        </span>
        <span className="text-slate-600">&middot;</span>
        <span className="text-slate-400">
          <strong className="text-white">
            {snapshot.meta.link_count.toLocaleString()}
          </strong>{' '}
          edges
        </span>
        <span className="text-slate-600">&middot;</span>
        <span className="text-slate-400">
          <strong className="text-white">
            {snapshot.meta.entity_classes.length}
          </strong>{' '}
          classes
        </span>
      </div>
    </div>
  );
}
